<template>
  <v-dialog v-model="show" persistent max-width="450">
    <v-card>
      <v-card-title>Unfile Ontario Spirits Return</v-card-title>
      <v-divider/>
      <v-card-text class="pt-4 body-1">
        Are you sure you want to unmark your Ontario Spirits Returns as filed?
        <div class="mt-4 warning--text">
          This will remove the book closing date for Ontario and allow transactions to
          be dated in a previously closed period.
          This can result in your records being inconsistent with filed returns.
        </div>
        <div class="mt-4">
          Note that any MOF payment transaction in QuickBooks Online will <strong>not</strong> be removed by unfiling.
          You will have to manually delete such transactions.
        </div>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn color="error" plain @click="unfile()" :loading="saving">Unfile</v-btn>
        <v-btn color="primary" @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  name: 'ReportsOntarioSpiritsUnfile',
  props: {
    value: {type:Boolean, required:true}
  },
  data() {
    return {
      show: this.value,
      saving: false
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    value() {
      this.show = this.value;
    },
  },
  methods: {
    async unfile() {
      this.saving = true;
      const results = await this.$apiCall(`mutation ReportsOntarioSpiritsUnfile {
                                              mofUnfile
                                            }`,
                                          {});
      this.saving = false;
      if (!results.error) {
        this.$store.commit('setError', {message:'Ontario Spirits Return unfiled',type:'success'});
        this.$emit('filed', '1999-12-31');
        this.cancel();
      }
    },
    cancel() {
      this.show = false;
      this.$emit('input', false);
    },
  }
}
</script>